var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInicio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 447.4 425.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-11,.cls-9{fill:#688c07;}.cls-2{isolation:isolate;}.cls-3{fill:#a6dfe2;}.cls-4{fill:#66aaad;}.cls-5{fill:#f4af1b;}.cls-6{fill:#ff141f;}.cls-7{fill:#d58136;}.cls-8{clip-path:url(#clip-path);}.cls-9{stroke:#77bcb4;stroke-width:1.14px;}.cls-11,.cls-14,.cls-16,.cls-25,.cls-9{stroke-miterlimit:10;}.cls-10{clip-path:url(#clip-path-2);}.cls-11{stroke:#72bfbb;stroke-width:1.22px;}.cls-12{clip-path:url(#clip-path-3);}.cls-13{fill:#001331;}.cls-14,.cls-16,.cls-25{fill:none;}.cls-14{stroke:#e5ab2a;}.cls-15,.cls-24{fill:#f0d054;}.cls-15,.cls-19,.cls-22,.cls-28{mix-blend-mode:multiply;}.cls-16{stroke:#f4af1b;}.cls-17{fill:#599992;}.cls-18,.cls-22{fill:#cde4ed;}.cls-20{fill:#72bfbb;}.cls-21{fill:#a1815d;}.cls-23{fill:#b0dee3;}.cls-25{stroke:#fff;stroke-width:1.04px;}.cls-26{fill:#649de1;}.cls-27{fill:#87c0ec;}.cls-28{fill:#5e749c;opacity:0.2;}.cls-29{fill:#ecb7a1;}.cls-30{fill:#1b2841;}.cls-31{fill:#243f5e;}.cls-32{fill:#2c635b;}.cls-33{fill:#37756e;}.cls-34{fill:#e8e8e8;}.cls-35{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-26.3 -40.31)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.57,388.51c22.36,19.3,61.56,10.52,61.56,10.52s3-40.06-19.41-59.36-61.57-10.53-61.57-10.53S135.2,369.21,157.57,388.51Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-26.3 -40.31)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.84,346.31c-18.45,22.73-57.29,21.77-57.29,21.77s-8.91-37.81,9.55-60.54,57.28-21.77,57.28-21.77S392.29,323.58,373.84,346.31Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(-26.3 -40.31)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.78,350c-18.41,7.2-25.46,33.15-25.46,33.15s22.8,14.26,41.2,7.05S388,357.08,388,357.08,365.19,342.82,346.78,350Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.56,137.69H34.73c-11,0-11-12.62-1.48-16C42.43,118.51,50.5,126,50.5,126s2.65-30.69,27.72-27.09c19.77,2.84,18.62,22.57,18.62,22.57s4.07-8.12,14.73-5C122.69,119.65,121.49,137.69,107.56,137.69Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M174.26,248.71H112.52c-9.31,0-9.3-10.69-1.25-13.52,7.78-2.73,14.63,3.63,14.63,3.63s2.24-26,23.49-23c16.76,2.41,15.78,19.14,15.78,19.14s3.45-6.89,12.49-4.28C187.09,233.42,186.07,248.71,174.26,248.71Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M345.36,67.21H295.2c-7.56,0-7.66-8.6-.95-10.33a14,14,0,0,1,11.81,2.29S307.88,38,325.15,40.51c13.61,2,12.82,15.55,12.82,15.55s2.8-5.6,10.15-3.48C355.78,54.79,355,67.21,345.36,67.21Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M458.54,130.08h-96c-14.47,0-14.65-16.47-1.8-19.78a26.75,26.75,0,0,1,22.6,4.39S386.81,74.22,419.86,79c26.06,3.75,24.54,29.76,24.54,29.76s5.37-10.71,19.42-6.66C478.49,106.3,476.9,130.08,458.54,130.08Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 104.38,
    cy: 401.43,
    rx: 42.3,
    ry: 8.77
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 209.92,
    cy: 413.85,
    rx: 166.55,
    ry: 11.92
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 227.17,
    cy: 112.25,
    rx: 97.89,
    ry: 19.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.07,131.26A12.69,12.69,0,0,0,235.64,119l22.13,3.14-3.15,22.15A12.73,12.73,0,1,1,252.23,161l-3.15,22.14-50-7.11a11.19,11.19,0,0,1-9.5-12.65l7.11-49.95L219,116.62a12.74,12.74,0,1,0,19.08,14.64Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M267,141.85a12.71,12.71,0,0,0-12.28,2.42l3.15-22.12L280,125.3a12.75,12.75,0,1,1,16.74,2.38l22.14,3.16-7.1,49.95a11.19,11.19,0,0,1-12.65,9.49l-49.95-7.1,3.16-22.25A12.74,12.74,0,1,0,267,141.85Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M248.66,102.31a12.72,12.72,0,0,0,12.27-2.43L257.79,122l-22.15-3.15a12.74,12.74,0,1,1-16.74-2.38l-22.14-3.15,7.11-49.95a11.18,11.18,0,0,1,12.65-9.5l50,7.11L263.3,83.23a12.74,12.74,0,1,0-14.64,19.08Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "248.54 127.74 251.73 139.87 292.61 135.65 289.01 117.91 248.54 127.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.57,388.51c22.36,19.3,61.56,10.52,61.56,10.52s3-40.06-19.41-59.36-61.57-10.53-61.57-10.53S135.2,369.21,157.57,388.51Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.57,388.51c22.36,19.3,61.56,10.52,61.56,10.52s3-40.06-19.41-59.36-61.57-10.53-61.57-10.53S135.2,369.21,157.57,388.51Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 194.89,
    y1: 360.64,
    x2: 109.66,
    y2: 287.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 178.71,
    y1: 302.37,
    x2: 176.1,
    y2: 344.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 149.06,
    y1: 276.78,
    x2: 146.45,
    y2: 318.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 160.49,
    y1: 330.95,
    x2: 117.65,
    y2: 332.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 140.71,
    y1: 313.74,
    x2: 111.75,
    y2: 314.52
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.84,346.31c-18.45,22.73-57.29,21.77-57.29,21.77s-8.91-37.81,9.55-60.54,57.28-21.77,57.28-21.77S392.29,323.58,373.84,346.31Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.84,346.31c-18.45,22.73-57.29,21.77-57.29,21.77s-8.91-37.81,9.55-60.54,57.28-21.77,57.28-21.77S392.29,323.58,373.84,346.31Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 288.58,
    y1: 330,
    x2: 358.92,
    y2: 243.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 295.2,
    y1: 271.12,
    x2: 304.08,
    y2: 310.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 319.66,
    y1: 240.98,
    x2: 328.55,
    y2: 280.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 316.97,
    y1: 295.03,
    x2: 358.21,
    y2: 288.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 333.27,
    y1: 274.79,
    x2: 361.08,
    y2: 270.04
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.78,350c-18.41,7.2-25.46,33.15-25.46,33.15s22.8,14.26,41.2,7.05S388,357.08,388,357.08,365.19,342.82,346.78,350Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.78,350c-18.41,7.2-25.46,33.15-25.46,33.15s22.8,14.26,41.2,7.05S388,357.08,388,357.08,365.19,342.82,346.78,350Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 293.24,
    y1: 343.49,
    x2: 363.41,
    y2: 316.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 332.79,
    y1: 352.12,
    x2: 308.71,
    y2: 337.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 357.2,
    y1: 342.56,
    x2: 333.12,
    y2: 327.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 321.56,
    y1: 332.4,
    x2: 333.91,
    y2: 306.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 337.93,
    y1: 326.07,
    x2: 346.51,
    y2: 308.69
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M325.09,311.61l17.48,129.26H196.89s5.21-32.59,8.88-60.27c1.53-11.61,2.8-22.35,3.28-29.47,0-.11,0-.21,0-.32-29.67-2.12-40.26-7.41-40.26-7.41V275.59l-30.73-8.47s14.31-45,13.78-55.63c0-10.06,4.76-58.35,4.76-58.35,13.74,26.71,201.74,24.56,192.83-4.47C394.16,219.59,336.94,298.9,325.09,311.61Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M302.56,216.73c11.41.59,17.14-6.26,18.32,7.11a81.86,81.86,0,0,1-1.16,22.59c-2.35,12.14-9,18.3-19.8,23.86",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M184.18,214.14s24.37,10.6,35-11.12",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M168.82,312.67a66,66,0,0,0,13.86,2.15,45.21,45.21,0,0,0,13.42-1.39,41.7,41.7,0,0,0,12.24-5.55,76.32,76.32,0,0,0,10.8-9,35.43,35.43,0,0,1-8.78,11.63,33.15,33.15,0,0,1-13.17,7,35.08,35.08,0,0,1-14.87.59A33.42,33.42,0,0,1,168.82,312.67Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M291.5,320.89c-19.28,43.17-85.73,59.71-85.73,59.71,1.53-11.61,2.8-22.35,3.28-29.47C251,350.71,277.64,332.57,291.5,320.89Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M209.08,350.81s62.16.83,86.51-35.24a19.09,19.09,0,0,0,2.83-7L302,291",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M222.9,446.89c0,2,2.11,3.61,4.71,3.61H367.49a.67.67,0,0,1,.74.57v4a.68.68,0,0,1-.74.56H213.56c-2.61,0-4.73-1.62-4.73-3.62V425.84c0-2,2.12-3.62,4.73-3.62H367.49a.67.67,0,0,1,.74.57v4c0,.3-.33.55-.74.55H227.61c-2.6,0-4.71,1.63-4.71,3.63Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M195.23,387.08H335.87a0,0,0,0,1,0,0V410.2a0,0,0,0,1,0,0H195.23a5,5,0,0,1-5-5V392A5,5,0,0,1,195.23,387.08Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 190.27,
    y: 402.27,
    width: 65.61,
    height: 1.67
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 190.27,
    y: 397.68,
    width: 107.98,
    height: 1.67
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 190.27,
    y: 393.49,
    width: 136.33,
    height: 1.67
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 205.72,
    y: 389.01,
    width: 108.22,
    height: 1.67
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 279.6,
    y: 402.27,
    width: 37.55,
    height: 1.67
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M372.46,404.87v15.25c0,1.16-1.19,2.1-3.63,2.1H211.13c-.39,0-.69-.14-.69-.33v-2.34c0-.18.3-.33.69-.33H355.68c2.44,0,4.41-.94,4.41-2.1v-9.24c0-1.17-2-2.11-4.41-2.11H211.13c-.39,0-.69-.15-.69-.33v-2.35c0-.18.3-.33.69-.33h157.7C371.27,402.76,372.46,403.71,372.46,404.87Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M369.08,410v5a4.79,4.79,0,0,1-.09.84,4.21,4.21,0,0,1-4.12,3.37H216.11V405.77H364.87a4.18,4.18,0,0,1,4.09,3.29A3.52,3.52,0,0,1,369.08,410Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 280,
    y: 368.76,
    width: 62.78,
    height: 1.67
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 239.46,
    y: 371.43,
    width: 103.32,
    height: 1.67
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 198.67,
    y: 373.87,
    width: 144.11,
    height: 1.67
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 210.79,
    y: 376.48,
    width: 117.2,
    height: 1.67
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 207.72,
    y: 368.76,
    width: 49.58,
    height: 1.67
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "165.37 354.18 165.39 373.04 164.42 371.23 163.46 373.04 162.49 371.23 161.53 373.05 160.56 371.23 159.59 373.05 158.63 371.23 157.67 373.05 157.65 354.19 165.37 354.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M222.38,455.67h-8.82c-2.61,0-4.73-1.62-4.73-3.62V425.84c0-2,2.12-3.62,4.73-3.62h-2.43c-.39,0-.69-.14-.69-.33v-2.34c0-.18.3-.33.69-.33h5V405.77h-5c-.39,0-.69-.15-.69-.33v-2.35c0-.18.3-.33.69-.33h11.19v3l0,13.45v36.45Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "190.3 417.97 146.65 418.01 138.56 418.03 138.51 372.57 138.49 355.49 190.22 355.43 190.3 417.97"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 164.8,
    y: 395.77,
    width: 51.73,
    height: 11.31,
    transform: "translate(-26.75 -40.1) rotate(-0.06)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 163.51,
    y: 394.49,
    width: 53.44,
    height: 11.31,
    transform: "translate(-26.75 -40.09) rotate(-0.07)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "168.51 354.17 168.53 373.04 167.56 371.22 166.6 373.04 165.63 371.23 164.67 373.04 163.7 371.23 162.74 373.04 161.77 371.23 160.81 373.05 160.79 354.18 168.51 354.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "146.68 372.58 146.65 418.01 138.56 418.03 138.51 372.57 146.68 372.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M122.86,391.89c1.1-5.84,4.44-11.36,9.73-14.32a21.14,21.14,0,0,1,10.08-3.07,23.33,23.33,0,0,1,9.06,1.88,20.46,20.46,0,0,1,11.16,10.85,21.92,21.92,0,0,1,.69,13c-1,4.18-3.3,8.48-1.75,12.84.44,1.24,1.72,2.61,1.33,4-.45,1.65-2.35,2.18-3.69,2.89l-4.79,2.53c-1.14.61-2.79,1.9-4.18,1.38s-1.8-2.26-2.6-3.32c-2.1-2.78-5.78-4-9-4.77a22.26,22.26,0,0,1-9.95-5.09A20.12,20.12,0,0,1,122.86,391.89Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M158.74,421.41s-5.32-10.84-7.63-16.31a24,24,0,0,1-1.74-5.42c-.3-1.59-.69-5.11,1.59-5.49,2.69-.44,2.44,3.47,1.32,4.9a6.89,6.89,0,0,1-4.79,2.07c-2.66-.11-5.07-2.46-5.93-4.74a1.73,1.73,0,0,1,2.79-1.87c1.27,1.11,2.85,6.8.25,8.38a6.4,6.4,0,0,1-4.62.71c-2.82-.58-3.48-5.23.12-3.93,2.56.92,4.63,3.64,6,5.87,3.68,6.1,6.41,11,10,17.14",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 151.45,
    y: 421,
    width: 12.23,
    height: 1.21,
    transform: "matrix(-0.88, 0.47, -0.47, -0.88, 469.64, 678.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M153.82,429.05a.7.7,0,0,0-.45-.79l-.1,0a.7.7,0,0,1-.45-.77l0-.2a.69.69,0,0,0-.48-.78.71.71,0,0,1-.49-.77l.08-.54a.64.64,0,0,1,.33-.47l10.7-5.75a.67.67,0,0,1,.57,0l.49.23a.71.71,0,0,1,.37.84.71.71,0,0,0,.39.83l.18.08a.73.73,0,0,1,.4.81l0,.1a.71.71,0,0,0,.41.81l.14.06a.72.72,0,0,1,.41.83l0,.07a1.32,1.32,0,0,1-.63.79l-10.34,5.55a1.32,1.32,0,0,1-1,.09l-.07,0a.72.72,0,0,1-.47-.8Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M152.86,426.34l-.06-.07a.21.21,0,0,1,.08-.27l5-2.68a.21.21,0,0,1,.27.08.2.2,0,0,1-.08.27l-5,2.69A.22.22,0,0,1,152.86,426.34Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M160.07,422.46l0-.06a.19.19,0,0,1,.08-.27l2.76-1.49a.21.21,0,0,1,.27.08.2.2,0,0,1-.08.27l-2.76,1.49A.19.19,0,0,1,160.07,422.46Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M157,425.69a.1.1,0,0,1,0-.06.21.21,0,0,1,.08-.27l7.23-3.88a.19.19,0,0,1,.27.08.2.2,0,0,1-.08.27l-7.23,3.88A.2.2,0,0,1,157,425.69Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M153.5,427.57a.34.34,0,0,1-.06-.06.21.21,0,0,1,.08-.27l2.14-1.15a.21.21,0,0,1,.27.08.2.2,0,0,1-.09.27l-2.13,1.15A.18.18,0,0,1,153.5,427.57Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M160.28,425.5l-.05-.06a.2.2,0,0,1,.08-.27l3.87-2.08a.2.2,0,0,1,.27.08.21.21,0,0,1-.08.27l-3.87,2.08A.24.24,0,0,1,160.28,425.5Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M156.2,427.69a.09.09,0,0,1-.06-.06.21.21,0,0,1,.08-.27l1.56-.83a.19.19,0,0,1,.27.08.21.21,0,0,1-.08.27l-1.56.83A.18.18,0,0,1,156.2,427.69Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M158.82,423.13l-.06-.06a.21.21,0,0,1,.08-.27l.56-.3a.21.21,0,0,1,.27.08.19.19,0,0,1-.08.27l-.56.3A.18.18,0,0,1,158.82,423.13Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M122.86,391.89c1.1-5.84,4.44-11.36,9.73-14.32.6-.34,1.22-.66,1.85-1-8.26,5.12-11.68,16.53-6.59,25.32,4.27,7.39,10.82,10.78,20.18,10a5,5,0,0,1,4.89,1.95c1.14,1.56,1.52,3.55,2.77,5a1.57,1.57,0,0,0,.69.54,1.84,1.84,0,0,0,.81,0,12.76,12.76,0,0,0,6-2.77,2,2,0,0,1-.07.42c-.45,1.65-2.35,2.18-3.69,2.89l-4.79,2.53c-1.14.61-2.79,1.9-4.18,1.38s-1.8-2.26-2.6-3.32c-2.1-2.78-5.78-4-9-4.77a22.26,22.26,0,0,1-9.95-5.09A20.12,20.12,0,0,1,122.86,391.89Z",
    transform: "translate(-26.3 -40.31)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 125.15,
    y: 413.31,
    width: 44.61,
    height: 45.53,
    transform: "translate(-315.09 542.73) rotate(-89.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M299.81,152c-21.72,1.61-49.69,20.94-34.74,58.86.14,3.33,2.39,5.46,4.42,4.58s-.53-6.94-.53-6.94c.34-29.47,6.51-35.26,18-36.44L313.73,169c6.73.23,19.31,3.52,23.73,26.59l6.81.48C342.9,179.15,335.43,149.33,299.81,152Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M299.43,148.56c-21.72,1.6-49.69,20.94-34.74,58.85l3.89-2.35c.34-29.48,6.51-35.26,17.95-36.44l26.81-3.07c6.74.23,19.77,4.72,24.2,27.79l6.35-.73C342.52,175.75,335.05,145.93,299.43,148.56Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M295.07,149.69l-2.41,7.42s.83,3.93,4.72,3.41,4.21-2.38,4.21-2.38l-.4-8.16Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M310.92,142c-2.93,6.88-4.33,9.08-9,10.59-6.05,2-13.48-1.44-11.4-12.11,1.69-8.7,5.82-7.86,9.76-8S314.09,134.51,310.92,142Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M295.8,138.48a2.63,2.63,0,0,0-2.9,1.05,3.25,3.25,0,0,0-.47,3.21,2.86,2.86,0,0,0-2.34,3.29c-1.29-2.28-1-4.82-1.5-7.24s-.5-5.11.87-7.16a7.89,7.89,0,0,1,2.17-2.1,12.36,12.36,0,0,1,11-1.4,6.73,6.73,0,0,0,5.06.32c4.6-1.68,7.72,1.21,5.22,4.52a3.79,3.79,0,0,1,2.5,1.35.73.73,0,0,1,.1.71.78.78,0,0,1-.4.31,5.11,5.11,0,0,1-2.46.48c.34.24,2.11.14,2.75,1.1,1.72,2.56-4,1.82-4.9,1.64,1,.07,3.77,1.82,3.11,3.31-.13.29-3.34,2.68-7.43-1.11a6.56,6.56,0,0,0-3.39-1.86,4.91,4.91,0,0,0-2.89.79c-.66.33-2.31,1.6-2.88,1S297,138.91,295.8,138.48Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M338.22,193.27c-.59,3.41-1.52,3.84-.3,4.24s2-1.56,2-1.56l5.48.46s-1.6-3.35-2.49-3.67S338.22,193.27,338.22,193.27Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M268.58,205.06c.9,1.66,1.09,1.65,2.3,3.63,2.32,3.79-1.34,10.6-4.83,4a19.31,19.31,0,0,1-1.36-5.29Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M336.92,204.81a11.39,11.39,0,0,0-1.55-11.1L355,197.66l-3.94,19.64a11.41,11.41,0,1,1-3,14.85l-3.95,19.64-42.67-8.58a11.69,11.69,0,0,1-9.16-13.76l8.58-42.68,19.74,4a11.41,11.41,0,1,0,16.32,14.07Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "331.02 231.46 328.6 236.33 334.52 238.75 335.15 233.14 331.02 231.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M360.9,255.9c-13.44,5.85-7.93,20,.25,18.36,4-.81,6-13.63,6-13.63Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M365.36,253.88a6.94,6.94,0,0,0-1.59-2.28,2,2,0,0,0-2.56-.14c-.9.84-.38,2.42.54,3.24-.79.1-1.72-.45-2.3.1s-.29,1.13,0,1.68a7.58,7.58,0,0,0,2.75,3.16c-.68.38-1.47,1.13-1.06,1.8.11.19.3.31.42.5.26.43,0,1-.26,1.42a23.27,23.27,0,0,1-1.37,2,1.21,1.21,0,0,1,1.93.34,2.3,2.3,0,0,1-1.56,2.85c-.37.09-2,5.12-.73,6.11,1.57,1.22,6.91.16,7.68-1.22a3.38,3.38,0,0,0,3,1.25,1.85,1.85,0,0,0,1.37-2.56,3.14,3.14,0,0,0,3.79-4.55c.66-.2.79-1.09.62-1.76a4.07,4.07,0,0,0-2.78-2.86,1.38,1.38,0,0,0,1.26-1.35,2.84,2.84,0,0,0-.75-1.85,6.34,6.34,0,0,0-4.62-2.21C367.23,257.35,366.2,255.43,365.36,253.88Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M352.77,397.72s-7.86,3.77-8.92,4.95c0,0,15.47.7,16.68,0s-2.47-4.93-2.47-4.93Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M382,393.45s-6.91,5.32-7.7,6.69c0,0,16.31-2.42,16.31-3.49s-3.44-4.3-3.44-4.3Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M360.37,324.83c-.29,1.6-11.05,44.09,19.75,69.57l8.92-2s-10.38-9.74-15.28-27.26c-4.63-16.57-.95-18.2,1.83-27.33,3.07-10.1.78-17.44.78-17.44Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M345.65,324.7c-4.88,11.67-13.26,51.43,5,73.82h9.12s-7.19-7.88-8-26.16,3.84-26.29,7.12-32.32,6.31-16.28,6.31-16.28Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M339.21,252.36c-2.42,8.54-3.22,24.33,8.92,30.69l8.13-2s-14.65-7.68-11.51-27.09Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M316.83,248l6.31-.78s-.76,26.49,29.83,28.72c23.35,1.7,25.18,45.52,25.18,45.52-7.53,5.07-20.16,6.61-36.35,5.45,0,0,1-31.27-1.54-39.82C340.26,287.07,314.85,279.07,316.83,248Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M309.12,243.18c-1.07,1.23,3.39,2.8,7.71,4.8l5.54-.68a22.42,22.42,0,0,0,0-2.26c-.07-1.15-.65-1.81-1.3-.82s-3.46,1.33-4.78.42S310.19,241.94,309.12,243.18Z",
    transform: "translate(-26.3 -40.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M339.21,252.36c-2-2-1.48-1.88-1.48-1.88l6.18,1.4s1.36-3,2.51-3.1-.86,2.08-.4,2.88-1.27,2.32-1.27,2.32Z",
    transform: "translate(-26.3 -40.31)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInicio);
export default __webpack_public_path__ + "static/media/inicio.ee6d03870aa716332db8634c6faaebc1.svg";
export { ForwardRef as ReactComponent };